import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * DESIGN.md Des5 — Lucide icon (32px, Mid-Gray, NO colored circle) + one-line context + primary CTA.
 * Reusable across every empty surface in the app.
 */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 px-6 text-center', className)}>
      <Icon className="size-8 text-foreground-muted mb-3" strokeWidth={1.5} aria-hidden />
      <p className="text-foreground font-medium text-[13px]">{title}</p>
      {description && <p className="text-foreground-muted text-[12px] mt-1 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
